import {Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, OnChanges} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UploadFileService } from '../../../../../core/services/upload-file.service';
import { UserService } from '../../../../../core/services/user.service';
import { PageParams } from '../../../../../core/models/page-params.model';
import { MatDialog } from '@angular/material/dialog';
import { AddTaxReportComponent } from '../../../../../shared/components/add-tax-report/add-tax-report.component';
import { ConfirmPopupDialog } from '../../../../../shared/popups/confirm-popup/confirm-popup.component';
import { TaxReportService } from '../../../../new-tax-report-management/services/tax-report.service';
import { TaxReportType } from '../../../../../shared/enums/tax-report-type.enum';

@Component({
    selector: 'eci-table-reported-tax-report',
    templateUrl: './table-reported-tax-report.component.html',
    styleUrls: ['./table-reported-tax-report.component.scss']
})
export class TableReportedTaxReportComponent implements OnInit {

    constructor(
        public userSvc: UserService,
        public uploadFileSvc: UploadFileService,
        private dialog: MatDialog,
        private notify: NotificationService,
        private taxReportSvc: TaxReportService,
    ) { }
    ReportTypeEnum = TaxReportType;
    
    @Input() reportType: number;
    @Input() dataSource;
    @Input() displayedColumns;
    @Input() pageParams: PageParams = new PageParams();
    @Output() pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>();
    @Output() removeTaxReport: EventEmitter<Number> = new EventEmitter<Number>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('table', { static: true }) table: any;

    showLoader = false;
    isAdmin = false;

    ngOnInit(): void {
        if(this.userSvc.isAdmin){
            this.isAdmin = true;
        }
    }

    uploadReport(): void {
        const dialogRef = this.dialog.open(AddTaxReportComponent, {
            autoFocus: false
        });
        dialogRef.componentInstance.reportType = this.reportType;
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.error) {
                this.notify.showError(result.error.message);
            } else {
                this.notify.showSuccessMessage(result.message);
                this.pageChange.emit(this.pageParams);
            }
        });
    }

    removeReport(reportId : number){
        const confirmDialog = this.dialog.open(ConfirmPopupDialog);
        confirmDialog.componentInstance.message = 'Are you sure, you want to remove this tax report?';
        confirmDialog.componentInstance.rightBtnText = 'Confirm';
        confirmDialog.afterClosed().subscribe((result: boolean) => {
            if (result === true) {
                this.removeTaxReport.emit(reportId);
            }
        });
    }

    downloadReport(report : any){
        this.taxReportSvc.downloadReportedTaxReport(report, this.reportType).subscribe();
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.pageChange.emit(this.pageParams);
    }

    sortData(sort: Sort): void {
        // sorting
    }

    getFlagClass(code: string) {
        return `iti__${code?.toLowerCase()}`;
    }


}
